var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcn02ChooseItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.191 21.294a2.45 2.45 0 110-4.901 2.45 2.45 0 010 4.901zM51.393 2.741L38.648 0v.364c0 4.942-4.02 8.962-8.962 8.962s-8.962-4.02-8.962-8.962V0L7.286 2.741 0 12.46l7.813 7.05 3.276-.938V56h37.19l.003-37.425 3.277.938 7.812-7.053-7.978-9.719z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgIcn02ChooseItem;